import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { backendUrl } from 'src/environments/environment';
import { toPromise } from './toPromise';
export interface WalletResponse {
  status: number;
  data: {
    total: number;
    wallet: Array<WalletHistory>;
  };
}

export interface WalletHistory {
  id: number;
  user_id: number;
  wallet: number;
  description: string;
  created_at: Date;
  updated_at: Date;
  deleted_at: Date;
}

export interface CheckPaymentResponse {
  status: number;
  data: Array<CheckPayment>;
}

export interface WalletAddResponse {
  status: number;
  data: CheckWalletPayment;
}
export interface CheckWalletPayment {
  created_at: Date;
  deleted_at: Date;
  id: number;
  payment_status: number;
  paypay_notify_id: number;
  paypay_notify_time: string;
  paypay_notify_type: string;
  reference_id: string;
  transaction_id: string;
  txn_amount: number;
  updated_at: Date;
  user_id: number;
  wallet_id: number;
}

export interface CheckPayment {
  id: number;
  order_number: number;
  user_id: number;
  seller_id: number;
  status: number;
  grand_total: number;
  discount: string;
  payment_status: number;
  payment_method: number;
  coupon_id: number;
  name: string;
  phone_number: number;
  delivery_name: string;
  delivery_phone_number: number;
  billing_locations: string;
  delivery_locations: string;
  notes: string;
  txn_no: string;
  delivery_option: string;
  delivery_status: string;
  paypay_order_no: string;
  created_at: Date;
  updated_at: Date;
  deleted_at: Date;
}

export interface PaymentMethod {
  status: number;
  data: [
    {
      id: number;
      name: string;
      img: string;
      status: number;
      gateway_id: string;
      name_pt: string;
    }
  ];
}

export interface BankDetailResponse {
  status: number;
  data: BankDetail;
}

export interface BankDetail {
  id: number;
  user_id: number;
  bank_account_name: string;
  bank_code: string;
  bank_iban: string;
  status: number;
  created_at: Date;
  updated_at: Date;
  deleted_at: Date;
}
export interface BankResponse {
  status: number;
  data: Array<BankData>;
}

export interface BankData {
  id: number;
  name: string;
  code: string;
  status: number;
}

@Injectable({
  providedIn: 'root',
})
export class WalletStore {
  constructor(private httpClient: HttpClient) {}

  async getWalletHistory(params = null): Promise<WalletResponse> {
    const url = `${backendUrl}wallet`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.get<WalletResponse>(url, {
        params: params,
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async checkPayment(orderId: number = null): Promise<CheckPaymentResponse> {
    const url = `${backendUrl}order-payment-status/${orderId}`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.get<CheckPaymentResponse>(url, {
        params: {},
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async walletPayment(orderId: number = null): Promise<WalletAddResponse> {
    const url = `${backendUrl}wallet-payment-status/${orderId}`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.get<WalletAddResponse>(url, {
        params: {},
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async addMoney(payload): Promise<void> {
    const url = `${backendUrl}wallet`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.post<void>(url, payload, {
        params: {},
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async paymentMethod(): Promise<PaymentMethod> {
    const url = `${backendUrl}payment-method`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.get<PaymentMethod>(url, {
        params: {},
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async addMoneyToBank(payload): Promise<void> {
    const url = `${backendUrl}wallet-to-bank-account`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.post<void>(url, payload, {
        params: {},
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async getBankDetail(): Promise<BankDetailResponse> {
    const url = `${backendUrl}bank-list`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.get<BankDetailResponse>(url, {
        params: {},
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }
  async getBanks(): Promise<BankResponse> {
    const url = `${backendUrl}standard-bank-codes`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.get<BankResponse>(url, {
        params: {},
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }
}
